import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import SplitPane from 'react-split-pane'

import InputSection from '../../views/Input'
import OutputSection from '../../views/Output'
import IllustrationSection from '../../views/Illustration'

import { getGlobalSettingsState } from '../../../../utils/selectors'

import debounce from 'lodash/debounce'

const getPaneClassName = (width) => {
  if (width < 540) return '-xs'
  else if (width < 768) return '-sm'
  else if (width < 992) return '-md'
  else if (width < 1600) return '-lg'
  else if (width < 2500) return '-xl'
  else return '-xxl'
}

const updatePaneClassName = (pane, length) => {
  const className = getPaneClassName(length) // length could be either width or height
  pane.classList.remove('-xs', '-sm', '-md', '-lg', '-xl', '-xxl')
  pane.classList.add(className)
  if (length < 250) {
    pane.classList.add('-minimized')
  } else {
    pane.classList.remove('-minimized')
  }
}

const DesktopView = () => {
  const orientation = useSelector((state) => getGlobalSettingsState(state).orientation)

  const primaryRef = useRef(null)
  const secondaryRef = useRef(null)

  let mediaClass = '-media-md'

  const adjustPrimaryPaneWidthHeight = () => {
    if (!primaryRef.current) {
      return
    }
    const pane1 = primaryRef.current.pane1
    const pane2 = primaryRef.current.pane2

    if (primaryRef.current.props.split === 'vertical') {
      updatePaneClassName(pane1, pane1.offsetWidth)
      updatePaneClassName(pane2, pane2.offsetWidth)
    } else {
      updatePaneClassName(pane1, pane1.offsetHeight)
      updatePaneClassName(pane2, pane2.offsetHeight)
    }
  }

  const adjustSecondaryPaneWidthHeight = () => {
    if (!secondaryRef.current) {
      return
    }
    const pane1 = secondaryRef.current.pane1
    const pane2 = secondaryRef.current.pane2

    if (secondaryRef.current.props.split === 'vertical') {
      updatePaneClassName(pane1, pane1.offsetWidth)
      updatePaneClassName(pane2, pane2.offsetWidth)
    } else {
      updatePaneClassName(pane1, pane1.offsetHeight)
      updatePaneClassName(pane2, pane2.offsetHeight)
    }
  }

  const handlePrimaryDragging = debounce(adjustPrimaryPaneWidthHeight, 200)
  const handleSecondaryDragging = debounce(adjustSecondaryPaneWidthHeight, 200)

  useEffect(() => {
    adjustPrimaryPaneWidthHeight()
    const handleResize = () => {
      adjustSecondaryPaneWidthHeight()
      adjustPrimaryPaneWidthHeight()
    }
    window.addEventListener('resize', handleResize)
  }, [])

  return (
    <SplitPane
      ref={primaryRef}
      defaultSize="36%"
      split={'vertical'}
      minSize={mediaClass === '-media-md' ? 26 : 32}
      onChange={handlePrimaryDragging}
    >
      <InputSection />

      <SplitPane
        ref={secondaryRef}
        defaultSize="50%"
        split={orientation}
        minSize={mediaClass === '-media-md' ? 26 : 32}
        onChange={handleSecondaryDragging}
      >
        <IllustrationSection />
        <OutputSection />
      </SplitPane>
    </SplitPane>
  )
}

export default DesktopView
